/**
 * tdesign v1.0.6
 * (c) 2023 TDesign Group
 * @license MIT
 */

var TNodeComponent = function TNodeComponent(props) {
  return props.content;
};
TNodeComponent.props = ["content"];

export { TNodeComponent as default };
//# sourceMappingURL=render-tnode.js.map
